import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import { getSalesReportTableProps, SalesReportTableProps } from './salesReportTableProps';

export const ReportTable = ({
  venueId,
  fromDate,
  toDate,
  selectedEmployeeId,
  selectedChannel,
  reportData,
}: SalesReportTableProps) => {
  const fromDateKey = fromDate.formatApiDateString();
  const toDateKey = toDate.formatApiDateString();

  const props = useMemo(
    () =>
      getSalesReportTableProps({
        venueId,
        fromDate,
        toDate,
        selectedEmployeeId,
        selectedChannel,
        reportData,
      }),
    [venueId, fromDateKey, toDateKey, selectedEmployeeId, selectedChannel, reportData],
  );

  return <Reconnect name="ReportTable" props={props} />;
};
